export const headerHeight = {
  xs: {
    wide: '90',
    thin: '50',
  },
  md: '60',
  lg: '70',
  xl: '70',
};
